import { useEffect, useState } from 'react';

import { JSErrors } from '@newrelic/browser-agent/features/jserrors';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { useSelector } from 'react-redux';

import { getUser } from '~/selectors/user.selectors';

import { newRelic } from './newRelic';

const useSetupNewRelic = () => {
  const [isInitialized, setIsInitialized] = useState(newRelic.isInitialized());

  // Initializes New Relic Browser Agent
  useEffect(() => {
    if (!CONFIG.newRelic.enabled) return;
    if (isInitialized) return;

    const instance = new BrowserAgent({
      features: [JSErrors],
      info: {
        applicationID: CONFIG.newRelic.applicationId,
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        jsAttributes: {},
        licenseKey: CONFIG.newRelic.licenseKey,
        sa: 1,
      },
      init: {
        ajax: { deny_list: ['bam.nr-data.net'] },
        distributed_tracing: { enabled: true },
        feature_flags: ['ajax_metrics_deny_list'],
        privacy: { cookies_enabled: true },
      },
      loader_config: {
        accountID: CONFIG.newRelic.accountId,
        agentID: CONFIG.newRelic.agentId,
        applicationID: CONFIG.newRelic.applicationId,
        licenseKey: CONFIG.newRelic.licenseKey,
        trustKey: CONFIG.newRelic.trustKey,
      },
    });
    instance.wrapLogger(console, 'error');
    newRelic.setInstance(instance);
    setIsInitialized(true);
  }, [isInitialized]);

  // Identifies user
  const user = useSelector(getUser);
  useEffect(() => {
    if (!CONFIG.newRelic.enabled) return;
    if (!user) return;
    if (!isInitialized) return;

    newRelic.setUserId(user.email);
  }, [user, isInitialized]);
};

export const NewRelicMonitor = () => {
  useSetupNewRelic();

  return null;
};
